module.exports = __webpack_public_path__ + "img/2025-06-11a_6.c71a0ac5.jpg";